module.exports = __webpack_public_path__ + "static/media/Rebecca-Ferriday.7b475697.jpg";